import React, { useEffect } from 'react';
import { PlumbBobIcon } from '../icons';

export const PointAgentContent: React.FC = () => {
    useEffect(() => {
      const schemas = [
        {
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Point Editor Agent',
          description: 'Precise point management and editing. Import, edit, and manage survey points, perform coordinate transformations, validate point data, and generate reports.',
          url: 'https://point.landsurv.ai',
          image: 'https://landsurv.ai/favicon-512.png',
          brand: { '@type': 'Brand', name: 'LandSurv.ai' },
          manufacturer: { '@type': 'Organization', name: 'LandSurv.ai', url: 'https://landsurv.ai' },
        },
        {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'LandSurv.ai', item: 'https://landsurv.ai' },
            { '@type': 'ListItem', position: 2, name: 'Agents', item: 'https://landsurv.ai?page=agents' },
            { '@type': 'ListItem', position: 3, name: 'Point Editor Agent', item: 'https://point.landsurv.ai' },
          ],
        },
      ];
      schemas.forEach((schema) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }, []);
    return (
        <div className="space-y-4">
            <div className="flex items-center gap-4 p-4 bg-gray-900/50 rounded-lg border border-gray-700">
                <PlumbBobIcon className="w-16 h-16 text-yellow-400 flex-shrink-0" />
                <div>
                    <h3 className="text-2xl font-bold text-yellow-400">Point Editor Agent</h3>
                    <p className="text-gray-300">The central hub for all your project's coordinate data.</p>
                </div>
            </div>
            <p>
                The Point Editor is the cornerstone of your project, providing a powerful, structured interface for managing all your survey points. Points generated by any other agent—from the RAW Crawler to the GPS Collector—are automatically consolidated here, creating a single source of truth for your coordinate data.
            </p>
            <ul className="list-disc list-inside space-y-2 pl-2 text-gray-300">
                <li><strong className="text-gray-100">Unified Point Database:</strong> View and manage points from all sources in one organized table.</li>
                <li><strong className="text-gray-100">Manual Entry & Editing:</strong> Directly add new points, edit existing coordinates, or delete points as needed.</li>
                <li><strong className="text-gray-100">Point List Management:</strong> Group points into logical lists (e.g., 'Control', 'Topo', 'Utilities'), toggle their visibility on the canvas, and import/export lists as .csv or .txt files.</li>
                <li><strong className="text-gray-100">AI-Powered COGO:</strong> Use the integrated chat to perform complex calculations. Ask to "inverse between two points," "check for duplicate coordinates," or "draw all points with 'tree' in the description."</li>
            </ul>
            <p>
                The Point Editor combines structured point list management with the analytical power of AI, making it an indispensable tool for data management and quality control.
            </p>
        </div>
    );
};
